module.exports = __webpack_public_path__ + "img/CONS.b6010139.jpg";